import { View, ObservableArray } from "binder";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { InternalTransferStatusEnumProvider } from "../internalTransferList/internalTransferList-viewModel";
import { CodeConversionCofrimListViewModel, CodeConversion } from "./codeConversionCofrimList-viewModel";

export class CodeConversionCofrimListView extends View<CodeConversionCofrimListViewModel>{
    GetViewUniqueId(): string {
        return "V-71746AF4-9DBE-4789-8B3F-520A53F331B4"
    }
    loadHtml(): string {
        let element = require('./codeConversionCofrimList.html').default;
        let style = require('./codeConversionCofrimList.less');
        return element;
    }
    constructor() {
       super();
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set codeConversions(v: ObservableArray<CodeConversion>) { this._codeConversions = v; } public get codeConversions(): ObservableArray<CodeConversion> { return this._codeConversions;} private _codeConversions: ObservableArray<CodeConversion>;
    public set internalTransferStatusEnumProvider(v: InternalTransferStatusEnumProvider) { this._internalTransferStatusEnumProvider = v; } public get internalTransferStatusEnumProvider(): InternalTransferStatusEnumProvider { return this._internalTransferStatusEnumProvider; } private _internalTransferStatusEnumProvider: InternalTransferStatusEnumProvider;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  
 
}
